<div class="perspective effect-rotate-left">
    <div class="container">
        <div class="outer-nav--return"></div>
        <div id="viewport" class="l-viewport">
            <img class="top-logo" src="assets/logo-top.png" alt="logo top">

            <div class="l-wrapper">
                <app-header> </app-header>
                <div class="main-structure">

                    <div class="sidebar">
                        <app-sidebar-nav></app-sidebar-nav>
                    </div>
                    <div class="main-content-div">
                        <app-main-content></app-main-content>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ul class="outer-nav">
        <li class="is-active">Home</li>
        <li>Why Us?</li>
        <li>Our Pitch</li>
        <li>Clients</li>
        <li>Pivoting Map</li>
        <li>Contact</li>
    </ul>
    <div class="centerspinner" id="loader">

        <app-loader></app-loader>

    </div>
</div>